import { apiPaths } from '../../config'
import { factorySetStateAction } from '../factory'
import { http } from '../../services/index'

// Defined Device Constants to bind SAGA functions with Redux Dispatcher
const actions = {
  SET_STATE: 'billing/SET_STATE',
  GET_BILLING_LIST: 'billing/GET_BILLING_LIST',
}

export const billingSetState = factorySetStateAction(actions.SET_STATE)

export const getBillingList = async (data) =>
  http
    .get(apiPaths.Clinic.apiBllingList, data, {})
    .then((res) => res)
    .catch(() => [])

export const getBllingPatientMonthly = async (data) =>
  http
    .get(`${apiPaths.Clinic.apiBllingPatientMonthly}/${data.patient_id}`, data, {})
    .then((res) => res)
    .catch(() => [])

export default actions
